import { createErrorNotice, createInfoNotice } from "@util/notices"

export default function () {
  let flash = history?.state?.flash

  if (flash?.info) {
    createInfoNotice(flash.info)
  } else if (flash?.error) {
    createErrorNotice(flash.error)
  }
}
